import axios from 'axios'
import {
  GET_REPORT_ALLTABLES_COUNT
  // REPORT_ALLTABLES_COUNT,
} from './action-constants'

const REPORT_ALLTABLESCOUNT = 'reports/alltablescount'

export function getAllTableCounts () {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + REPORT_ALLTABLESCOUNT
  return {
    type: GET_REPORT_ALLTABLES_COUNT,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}
